import { GetterTree, ActionTree, MutationTree } from "vuex/types"
import { RootState } from "~/store/store.types"

export interface ModalState {
  data: string[]
  meta: {
    target: HTMLElement[]
  }
}

export const namespaced = true

export const state = (): ModalState => ({
  data: [],
  meta: {
    target: []
  }
})

export const getters: GetterTree<ModalState, RootState> = {
  openModals (state) {
    return state.data || []
  }
}

export const actions: ActionTree<ModalState, RootState> = {
  open ({ commit }, params) {
    commit('open', params)
  },
  close ({ commit }, name) {
    commit('close', name)
  },
  target ({ commit }, name) {
    commit('target', name)
  }
}

export const mutations: MutationTree<ModalState> = {
  open (state, name) {
    if (!state.data.includes(name)) {
      state.data.push(name)
    } else {
      console.warn('$ui.modal.open - open action rejected, modal is already open.')
    }
  },
  close (state, name) {
    state.data = state.data.filter(modal => modal !== name)

    if (state.meta.target && state.meta.target.length > 0) {
      const target = state.meta.target.pop()
      if (target) {
        target.focus()
      }
    }
  },
  target (state, evt) {
    if (evt) {
      state.meta.target.push(evt)
    }
  }
}
